import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { numberMaskWithoutDecimalOption } from 'aurora-utils/constants';
import messages from 'aurora-translations';
import ADGMTextField from '../../../ADGMTextField';
import ADGMButton from '../../../ADGMButton';
import styles from './styles';

function TextFieldFetch(props) {
  const {
    classes,
    intl,
    buttonDisabled,
    buttonText,
    description,
    alertType,
    handleFetch,
    label,
    placeholder,
    type,
    ...fieldProps
  } = props;

  const handleClick = () => {
    const { value } = fieldProps;
    const id = value?.replaceAll('-', '')?.trim();
    handleFetch && handleFetch(id);
  };

  return (
    <div>
      <div className={classes.container}>
        <ADGMTextField
          label={messages[label]?.id ? intl.formatMessage({ ...messages[label] }) : label}
          placeholder={messages[placeholder]?.id ? intl.formatMessage({ ...messages[placeholder] }) : placeholder}
          mask={type !== 'text' && createNumberMask(numberMaskWithoutDecimalOption)}
          {...fieldProps}
        />
        <ADGMButton variant='secondary' disabled={buttonDisabled} onClick={handleClick}>
          {messages[buttonText]?.id ? <FormattedMessage {...messages[buttonText]} /> : buttonText}
        </ADGMButton>
      </div>
      {description && (
        <div className={classes.informationMessage}>
          {messages[description]?.id ? <FormattedMessage {...messages[description]} /> : description}
        </div>
      )}
    </div>
  );
}

TextFieldFetch.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  buttonDisabled: PropTypes.bool,
  buttonText: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string.isRequired,
  handleFetch: PropTypes.func.isRequired,
  alertType: PropTypes.string,
  type: PropTypes.string,
};

TextFieldFetch.defaultProps = {
  buttonDisabled: false,
  buttonText: 'fetch',
  alertType: 'info',
  label: '',
  placeholder: '',
  type: '',
};

export default injectIntl(withStyles(styles)(TextFieldFetch));
